import { BrokerUser, BrokerUserStatus } from '@/services/broker-users/types';

const now = () => new Date().toISOString();

export const mockBrokers = [
  { id: 'BRK-001', name: 'Atlas Corretora', cnpj: '12.345.678/0001-90' },
  { id: 'BRK-002', name: 'Horizonte Seguros', cnpj: '98.765.432/0001-10' },
  { id: 'BRK-003', name: 'Delta Proteção', cnpj: '45.987.321/0001-55' },
  { id: 'BRK-004', name: 'Seguro Fácil', cnpj: '11.222.333/0001-44' },
];

const makeUser = (
  partial: Partial<BrokerUser> & Required<Pick<BrokerUser, 'id'>>
): BrokerUser => ({
  id: partial.id,
  name: partial.name ?? 'Usuário sem nome',
  email: partial.email ?? 'contato@example.com',
  cpf: partial.cpf ?? '00000000000',
  brokerId: partial.brokerId ?? 'BRK-001',
  brokerName:
    partial.brokerName ??
    mockBrokers.find(b => b.id === partial.brokerId)?.name ??
    'Corretora',
  role: partial.role ?? 'interno',
  profile: partial.profile ?? 'user',
  status: partial.status ?? 'ACTIVE',
  lastStatusChangeAt: partial.lastStatusChangeAt ?? now(),
  lastStatusChangeBy: partial.lastStatusChangeBy ?? 'Sistema',
});

export const mockBrokerUsersDb: BrokerUser[] = [
  makeUser({
    id: 'USR-100',
    name: 'Ana Bezerra',
    email: 'ana.bezerra@atlas.com',
    cpf: '12345678901',
    brokerId: 'BRK-001',
    role: 'master',
    profile: 'Master',
    status: 'ACTIVE',
    lastStatusChangeBy: 'Administrador',
  }),
  makeUser({
    id: 'USR-101',
    name: 'Bruno Lima',
    email: 'bruno.lima@atlas.com',
    cpf: '32165498700',
    brokerId: 'BRK-001',
    role: 'interno',
    profile: 'Operacional',
    status: 'INACTIVE',
    lastStatusChangeBy: 'Administrador',
  }),
  makeUser({
    id: 'USR-102',
    name: 'Carla Nogueira',
    email: 'carla.nogueira@horizonte.com',
    cpf: '98765432100',
    brokerId: 'BRK-002',
    brokerName: 'Horizonte Seguros',
    role: 'interno',
    profile: 'Atendimento',
    status: 'PENDING',
    lastStatusChangeBy: 'Sistema',
  }),
  makeUser({
    id: 'USR-103',
    name: 'Diego Souza',
    email: 'diego.souza@horizonte.com',
    cpf: '45678912300',
    brokerId: 'BRK-002',
    brokerName: 'Horizonte Seguros',
    role: 'interno',
    profile: 'Subscritor',
    status: 'ACTIVE',
  }),
  makeUser({
    id: 'USR-104',
    name: 'Eduarda Ribeiro',
    email: 'eduarda.ribeiro@delta.com',
    cpf: '74185296300',
    brokerId: 'BRK-003',
    brokerName: 'Delta Proteção',
    role: 'interno',
    profile: 'Financeiro',
    status: 'ACTIVE',
  }),
  makeUser({
    id: 'USR-105',
    name: 'Felipe Costa',
    email: 'felipe.costa@delta.com',
    cpf: '15975348600',
    brokerId: 'BRK-003',
    brokerName: 'Delta Proteção',
    role: 'interno',
    profile: 'Atendimento',
    status: 'INACTIVE',
    lastStatusChangeBy: 'Administrador',
  }),
  makeUser({
    id: 'USR-106',
    name: 'Gabriela Teles',
    email: 'gabriela.teles@segurofacil.com',
    cpf: '25836914700',
    brokerId: 'BRK-004',
    brokerName: 'Seguro Fácil',
    role: 'master',
    profile: 'Master',
    status: 'ACTIVE',
  }),
  makeUser({
    id: 'USR-107',
    name: 'Henrique Duarte',
    email: 'henrique.duarte@segurofacil.com',
    cpf: '36925814700',
    brokerId: 'BRK-004',
    brokerName: 'Seguro Fácil',
    role: 'interno',
    profile: 'Operacional',
    status: 'ACTIVE',
  }),
  makeUser({
    id: 'USR-108',
    name: 'Isabela Prado',
    email: 'isabela.prado@atlas.com',
    cpf: '85274196300',
    brokerId: 'BRK-001',
    role: 'interno',
    profile: 'Atendimento',
    status: 'ACTIVE',
  }),
  makeUser({
    id: 'USR-109',
    name: 'João Victor',
    email: 'joao.victor@horizonte.com',
    cpf: '14725836900',
    brokerId: 'BRK-002',
    brokerName: 'Horizonte Seguros',
    role: 'interno',
    profile: 'Comercial',
    status: 'PENDING',
  }),
  makeUser({
    id: 'USR-110',
    name: 'Karen Farias',
    email: 'karen.farias@delta.com',
    cpf: '65498732100',
    brokerId: 'BRK-003',
    brokerName: 'Delta Proteção',
    role: 'interno',
    profile: 'Operacional',
    status: 'ACTIVE',
  }),
  makeUser({
    id: 'USR-111',
    name: 'Leonardo Alves',
    email: 'leonardo.alves@atlas.com',
    cpf: '96385274100',
    brokerId: 'BRK-001',
    role: 'interno',
    profile: 'Financeiro',
    status: 'INACTIVE',
    lastStatusChangeBy: 'Administrador',
  }),
];

export const mockStatusLabels: Record<BrokerUserStatus, string> = {
  ACTIVE: 'Ativo',
  INACTIVE: 'Inativo',
  PENDING: 'Primeiro acesso',
  FORCE_CHANGE_PASSWORD: 'Primeiro acesso',
};
